import ApiService from '@core/api/services/ApiService';
import matchesSchema from '@helpers/matchesSchema';
import React from 'react';
export var OneTrustStatus;
(function (OneTrustStatus) {
    OneTrustStatus[OneTrustStatus["None"] = 0] = "None";
    OneTrustStatus[OneTrustStatus["Loading"] = 1] = "Loading";
    OneTrustStatus[OneTrustStatus["NoScriptId"] = 2] = "NoScriptId";
    OneTrustStatus[OneTrustStatus["Loaded"] = 3] = "Loaded";
    OneTrustStatus[OneTrustStatus["LoadedMissingSchema"] = 4] = "LoadedMissingSchema";
    OneTrustStatus[OneTrustStatus["Errored"] = 5] = "Errored";
    OneTrustStatus[OneTrustStatus["ErroredLoading"] = 6] = "ErroredLoading";
    OneTrustStatus[OneTrustStatus["AcceptNecessaryError"] = 7] = "AcceptNecessaryError";
})(OneTrustStatus || (OneTrustStatus = {}));
const POLLING_INTERVAL = 100;
export default function useOneTrust(props) {
    const [status, setStatus] = React.useState(OneTrustStatus.None);
    const loadOneTrust = async () => {
        const promise = new Promise((resolve) => {
            try {
                if (!props.oneTrustScriptID) {
                    setStatus(OneTrustStatus.NoScriptId);
                    return resolve(undefined);
                }
                if (window.OneTrust) {
                    setStatus(OneTrustStatus.Loaded);
                    return resolve(window.OneTrust);
                }
                const script = document.createElement('script');
                script.src = 'https://cdn.cookielaw.org/scripttemplates/otSDKStub.js';
                script.type = 'text/javascript';
                script.charset = 'UTF-8';
                script.setAttribute('data-domain-script', props.oneTrustScriptID);
                script.addEventListener('load', () => {
                    const handle = window.setInterval(async () => {
                        if (window.OneTrust) {
                            const element = document.querySelector('#onetrust-consent-sdk');
                            if (element) {
                                console.log('one trust loaded!', window.OneTrust);
                                window.clearInterval(handle);
                                if (!matchesSchema(window.OneTrust, ['IsAlertBoxClosed', 'ToggleInfoDisplay', 'AllowAll', 'Close'])) {
                                    await logError('OneTrust schema does not match expected schema');
                                    setStatus(OneTrustStatus.LoadedMissingSchema);
                                    return resolve(window.OneTrust);
                                }
                                setStatus(OneTrustStatus.Loaded);
                                return resolve(window.OneTrust);
                            }
                        }
                        setStatus(OneTrustStatus.Loading);
                    }, POLLING_INTERVAL);
                });
                script.addEventListener('error', async (e) => {
                    setStatus(OneTrustStatus.ErroredLoading);
                    await logError(e.message);
                    return resolve(undefined);
                });
                document.head.appendChild(script);
            }
            catch (e) {
                setStatus(OneTrustStatus.ErroredLoading);
                logError(e.message);
                return resolve(undefined);
            }
        });
        return promise;
    };
    const logError = async (error, status) => {
        if (status !== undefined) {
            setStatus(status);
        }
        await ApiService.request({
            method: 'POST',
            controller: 'one-trust',
            slug: 'log-error',
            params: {
                cultureCode: props.cultureCode,
                message: error,
            },
        });
    };
    return { status, loadOneTrust, logError };
}
